import request from '@ps/utils/request'
import { AxiosRequestConfig } from 'axios'
import { ResponseData } from 'request'

export function getComponentList(
  params: {
    cat_ids?: string
    type: number
    pid: number
    page: number
    page_size: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: '/ps/asset/list',
    method: 'get',
    params: params,
    ...config,
  })
}

/**
 * 读取资源组件
 * @param params.id 资源 id ，如果是用户资源库 id 需要传 string
 * @param params.from 资源类型 1 公共资源库 2 新公共资源库 3 用户资源库
 * @param params.pid 项目 id, 只有是用户资源库的时候才需要传
 */
export function readComponent(params: {
  id: number | string
  from: number
  pid: number
}) {
  return request({
    url: '/ps/asset/read',
    method: 'get',
    params: params,
  })
}

export type AssetCreateResponse = {
  file_url: string
  id: number
  icon_url: string
  name: string
  file_type: string
  file_size: number
  file_md5: string
  extra: {
    width: number
    height: number
    duration: number
  }
}

export function createComponent(data: FormData) {
  return request<ResponseData<AssetCreateResponse>>({
    url: '/ps/asset/create',
    method: 'post',
    data: data,
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
}

export function deleteComponent(data: { id: number }) {
  return request({
    url: `/ps/asset/delete?id=${data.id}`,
    method: 'post',
  })
}
